<template>
  <div class="flex flex-col">
    <div class="overflow-x-auto lg:-mx-8 lg:px-8">
      <div class="inline-block min-w-full overflow-hidden align-middle border border-gray-200 shadow sm:rounded">
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                colspan="2"
                class="px-6 py-3 text-lg font-medium leading-4 text-left text-gray-800 bg-gray-100 border-b border-gray-200"
              >
                Kostenrechnung
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Einkaufspreis
              </td>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200">
                {{ calculation.item_price_purchased | price('EUR') }}
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Mögliche Prämien
              </td>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200">
                - {{ calculation.item_provision_requestable | price('EUR') }}
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Subventionen
              </td>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200">
                <template v-if="calculation.item_pool_payouts !== null">
                  - {{ calculation.item_pool_payouts | price('EUR') }}
                </template>
                <template v-else>
                  - {{ 0 | price('EUR') }}
                </template>
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Kosten
              </td>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200">
                + {{ calculation.item_costs | price('EUR') }}
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Überführung
              </td>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200">
                + {{ calculation.item_basecharge | price('EUR') }}
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium font-bold leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Mindestpreis
              </td>
              <td
                colspan="2"
                class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200"
              >
                <span class="block font-bold underline">= {{ calculation.item_minimal_price | price('EUR') }} Netto</span>
                <span class="block">= {{ addVat(calculation.item_minimal_price) | price('EUR') }} Brutto</span>
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Bruttolistenpreis
              </td>
              <td
                colspan="2"
                class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200"
              >
                {{ calculation.item_gross_list_price | price('EUR') }}
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                Erparnis zum BLP
              </td>
              <td
                colspan="2"
                class="px-6 py-4 text-sm font-medium leading-5 text-right text-gray-900 whitespace-no-wrap border-b border-gray-200"
              >
                {{ ((1 - ((addVat(calculation.item_minimal_price)) / calculation.item_gross_list_price)) * 100) | price('EUR') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getCalculatedCarPrice } from '@/api/cars'
import CalculatesVat from '@/mixins/CalculatesVat'

export default {
  name: 'MiaCarCalculation',

  mixins: [CalculatesVat],

  data() {
    return {
      calculation: {
        item_price_purchased: 0,
        item_tax: 'default',
        item_price_sold: 0,
        item_price_sold_gross: 0,
        item_gross_list_price: 0,
        item_net_list_price: 0,
        item_provision_requested: 0,
        item_pool_payouts: null,
        item_costs: 0,
        item_costs_gross: 0,
        item_financial_values: 0,
        item_accessories_sold: 0,
        item_basecharge: 0,
        item_revenue_base: 0,
        item_revenue_base_gross: 0,
        item_revenue: 0,
        item_revenue_gross: 0,
        item_profit_ratio: 0,
        item_profit_margin: 0,
        item_provision_requestable: 0,
        item_minimal_price: 0
      }
    }
  },

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  },

  async created() {
    this.calculation = await getCalculatedCarPrice(this.car.id)
  }
}
</script>
